import React, { useState } from "react";
import "./index.css";

const DealsFaqSection = ({ faqData = {} }) => {
  const { heading, description, qas } = faqData || {};
  const safeQas = Array.isArray(qas) ? qas : [];
  const [openIndex, setOpenIndex] = useState(safeQas.length ? 0 : -1);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? -1 : i));
  };

  if(!heading && !description && safeQas.length === 0) {
    return null; // Don't render the section if there's no content
  }

  return (
    <section className="deals-faq-section">
      <div className="deals-faq-inner">
        <aside className="deals-faq-left">
          {heading && <h2 className="deals-faq-heading">{heading}</h2>}
          {description && (
            <div
              className="deals-faq-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </aside>

        <div className="deals-faq-right">
         

          {safeQas.map((qa = {}, i) => (
            <div
              key={i}
              className={`faq-item ${openIndex === i ? "open" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
              >
                <span className="question-text">{qa.question || "Untitled question"}</span>
                <span className="question-icon">{openIndex === i ? "×" : "+"}</span>
              </button>

              <div className="faq-answer">
                {qa.answer ? (
                  <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
                ) : (
                  <p>No answer available.</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealsFaqSection;
